export default __webpack_public_path__ + "static/media/01_tag_free-wifi.3a0d2759.svg";